import { _decorator, Component, Slider, Node } from 'cc';
import NumberFormatter from '../Label/NumberFormatter';

const { ccclass, property, requireComponent, executionOrder } = _decorator;

enum EventType {
    PROGRESS_CHANGED = 'PROGRESS_CHANGED',
}

@ccclass('RangeSlider')
@requireComponent(Slider)
@executionOrder(111)
export default class RangeSlider extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property
    public readonly min: number = 0.0;

    @property
    public readonly max: number = 1;

    @property({ min: 0 })
    public readonly step: number = 0.1;

    @property(NumberFormatter)
    public readonly valueNumber: NumberFormatter = null;

    @property
    private readonly cancelTouch = false;

    private _slider: Slider = null;

    public get value() {
        return this.progressValueMapping(this.slider.progress);
    }

    public get progress() {
        return this.slider.progress;
    }

    public set progress(value: number) {
        this.slider.progress = value;
    }

    private get slider() {
        if (!this._slider) {
            this._slider = this.getComponent(Slider);
        }
        return this._slider;
    }

    public progressValueMapping: (progress: number) => number = (t) => {
        const v = t * (this.max - this.min) + this.min;
        return v - (v % this.step);
    };

    public onLoad() {
        this.slider.on(Slider.EventType.PROGRESS_CHANGED, this._onSliderValueChanged, this);
    }

    public onEnable() {
        if (this.cancelTouch) {
            this.node.off(Node.EventType.TOUCH_START);
            this.node.off(Node.EventType.TOUCH_MOVE);
            this.node.off(Node.EventType.TOUCH_END);
            this.node.off(Node.EventType.TOUCH_CANCEL);
        }
    }

    private _onSliderValueChanged() {
        if (this.valueNumber) {
            this.valueNumber.value = this.value;
        }
        this.node.emit(EventType.PROGRESS_CHANGED);
    }
}
